<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="info"
        block
        rounded
        :height="isMobile() ? 35 : 32"
      >
        <v-icon size="17" class="mr-2">mdi-pencil-lock-outline</v-icon> Alterar
        senha</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold"> Alterar senha </v-card-title>
      <v-card-text class="pt-5">
        <v-form ref="form">
          <v-text-field
            label="Senha atual"
            :type="visualizarSenhaAtual ? 'text' : 'password'"
            v-model="senhaAtual"
            :rules="rulesSenhaAtual"
            class="mb-4"
            :append-icon="visualizarSenhaAtual ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="visualizarSenhaAtual = !visualizarSenhaAtual"
          ></v-text-field>
          <v-text-field
            label="Nova senha"
            :type="visualizarNovaSenha ? 'text' : 'password'"
            v-model="novaSenha"
            :rules="rulesNovaSenha"
            :append-icon="visualizarNovaSenha ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="visualizarNovaSenha = !visualizarNovaSenha"
          ></v-text-field>
          <v-text-field
            label="Senha de confirmação"
            type="password"
            v-model="senhaConf"
            :rules="rulesSenhaConf"
          ></v-text-field>
          <v-btn
            block
            rounded
            color="success"
            @click="confirmarAlteracaoSenha()"
            :loading="alterandoSenha"
            class="mt-4"
            >Confirmar alteração</v-btn
          >
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false" rounded>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  watch: {
    dialog: function (open) {
      if (open) {
        this.senhaAtual = "";
        this.novaSenha = "";
        this.senhaConf = "";
      }
    },
  },
  data: () => ({
    dialog: false,
    alterandoSenha: false,
    senhaAtual: "",
    novaSenha: "",
    senhaConf: "",
    visualizarSenhaAtual: false,
    visualizarNovaSenha: false,
    rulesSenhaAtual: [(v) => !!v || "Informe a senha atual"],
    rulesNovaSenha: [
      (v) => !!v || "Informe a sua nova senha",
      (v) => v.length > 7 || "Sua senha deve conter pelo menos 8 caracteres",
    ],
    rulesSenhaConf: [(v) => !!v || "Informe a confirmação de senha"],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    async confirmarAlteracaoSenha() {
      if (this.$refs.form.validate()) {
        this.alterandoSenha = true;

        await axios
          .post(
            "/nutricao-animal/usuario/alterar-senha",
            JSON.stringify({
              senha_atual: this.senhaAtual,
              nova_senha: this.novaSenha,
              senha_conf: this.senhaConf,
            })
          )
          .then((res) => {
            if (res.data.success) {
              this.dialog = false;
              this.$toasted.success(res.data.msg);
            } else {
              this.$toasted.error(res.data.msg);
            }
          })
          .catch((e) => {
            this.$toasted.error(e);
          });
        this.alterandoSenha = false;
      }
    },
  },
  mounted() {
    this.rulesSenhaConf.push(
      (v) => v == this.novaSenha || "Confirmação de senha não confere"
    );
  },
};
</script>

<style>
</style>